import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { MockMentions, MockVariables } from '@demo/data';
import { FroalaConfig } from '@shared/components/froala/common';
import { FroalaComponent } from '@shared/components/froala/froala.component';
import { CipoFroalaOptions, CipoTributeOptions } from '@shared/components/froala/interfaces';
import { UtilsService } from '@shared/services';

const DEMO_FROALA_CONTENT_KEY = 'froalaContent';

@Component({
  selector: 'app-demo-froala',
  templateUrl: './demo-froala.component.html',
  imports: [FroalaComponent, MatButtonToggleModule, FlexLayoutModule],
})
export class DemoFroalaComponent {
  options: CipoFroalaOptions = {
    charCounterMax: 100,
  };
  required = false;
  hint = 'This is a hint';
  label = 'This is a label';
  initialValue = '';
  tributeOptions: CipoTributeOptions = {
    variables: MockVariables,
    mentions: this.utilsService.mapArrayToObject(MockMentions),
  };
  editMode = true;
  control = new FormControl(this.initialValue);

  froalaInlineOptions: CipoFroalaOptions = {
    ...FroalaConfig.inline,
    toolbarVisibleWithoutSelection: true,
    heightMax: 200,
  };

  constructor(private utilsService: UtilsService) {
    this.initialValue = localStorage.getItem(DEMO_FROALA_CONTENT_KEY) ?? '';
  }
  updateContent(content: string) {
    localStorage.setItem(DEMO_FROALA_CONTENT_KEY, content);
  }
}
